{
  "mode": "throw",
  "order": "row-major"
}
